import { Component, OnInit } from '@angular/core'
import { Router, ActivatedRoute, Params } from '@angular/router'

@Component({
  selector: 'app-errors',
  templateUrl: './errors.component.html',
  styleUrls: ['./errors.component.css']
})
export class ErrorsComponent implements OnInit {
  
  tipo: String
  descripcion: String
  constructor(private activatedRoute: ActivatedRoute) { }

  construirDescripcion(tipo) {
    switch (tipo) {
      case '403':
        this.descripcion = 'No tienes permiso para acceder a este servicio'
        break
    }
  }
  ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.tipo = params['type']
      this.construirDescripcion(this.tipo)
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/errors/errors.component.ts